import React, { useRef, useState } from "react";
import BgSound from "../../../assets/topstudio/audio/TpbgSound.mp3";

export default function Volume({
  id = "TpStudioSoundcontrol",
  style,
  className = ""
}) {
  const audioRef = useRef(null);
  const [soundEnabled, setSoundEnabled] = useState(false);

  const playBGSoundWithRetry = () => {
    const audio = audioRef.current;
    if (!audio) return;
    audio.play().catch(() => {
      setTimeout(() => audio.play().catch(() => {}), 250);
    });
  };

  const toggleSound = (e) => {
    const on = e.target.checked;
    setSoundEnabled(on);
    if (on) {
      playBGSoundWithRetry();
    } else {
      audioRef.current?.pause();
    }
  };

  return (
    <>
      <audio ref={audioRef} src={BgSound} loop />
      <label
        htmlFor={id}
        className={`sound-icon ${className}`.trim()}
        style={{
          cursor: "pointer",
          color: "#fff",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          lineHeight: 1,
          ...style
        }}
        title="Toggle sound"
      >
        <input
          id={id}
          type="checkbox"
          checked={soundEnabled}
          onChange={toggleSound}
          style={{ display: "none" }}
        />
        <i
          className={`fa-solid ${
            soundEnabled ? "fa-volume-high" : "fa-volume-off"
          }`}
          style={{ fontSize: "18px" }}
          aria-hidden="true"
        />
      </label>
    </>
  );
}
